import React, { ChangeEvent, Component } from "react";
import "./FeedbackReviewModal.scss";
import IOnSubmitReviewDTO from "../../../models/DTO/IOnSubmitReviewDTO";
import ISubmitReviewDTO from "../../../models/DTO/ISubmitReviewDTO";
import IReviewLink from "../../../models/IReviewLink";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import WhatsThis from "../../shared/WhatsThis/WhatsThis";
import OwStarRating from "../../shared/OwStarRating/OwStarRating";
import Confetti from "react-confetti";
import { Socket } from "socket.io-client";

type Props = {
    userModel?: IUserUI;
    supplierModel?: ISupplierModel;
    socket: Socket;
    closeModal: () => void;
};

type State = {
    currentSlide: number;
    addl_feedback: string;
    what_like_least: string;
    what_like_most: string;
    nextDisabled: boolean;
    submitActive: boolean;
    submitDisabled: boolean;
    overall_quality: number;
    ease_of_use: number;
    features_and_functionality: number;
    value_for_money: number;
    would_you_recommend_us: number;
    customer_support: number;
    averageRating?: number;
    reviewLinks: IReviewLink[];
    showConfetti: boolean;
};

class FeedbackReviewModal extends Component<Props, State> {
    readonly state: State = {
        currentSlide: 1,
        addl_feedback: "",
        what_like_least: "",
        what_like_most: "",
        nextDisabled: true,
        submitDisabled: true,
        submitActive: false,
        overall_quality: 0,
        ease_of_use: 0,
        features_and_functionality: 0,
        value_for_money: 0,
        would_you_recommend_us: 0,
        customer_support: 0,
        reviewLinks: [],
        showConfetti: false,
    };

    componentDidMount() {
        this.props.socket.on("onSubmitReview", this.onSubmitReview);
    }

    componentWillUnmount() {
        this.props.socket.removeListener("onSubmitReview", this.onSubmitReview);
    }

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            if (
                this.state.overall_quality &&
                this.state.ease_of_use &&
                this.state.features_and_functionality &&
                this.state.value_for_money &&
                this.state.would_you_recommend_us
            ) {
                this.setState({
                    nextDisabled: false,
                });
            } else {
                if (this.state.nextDisabled) {
                    this.setState({
                        nextDisabled: true,
                    });
                }
            }

            if (this.state.what_like_most.length && this.state.what_like_least) {
                this.setState({
                    submitDisabled: false,
                });
            } else {
                this.setState({
                    submitDisabled: true,
                });
            }
        });
    };

    stepBack = () => {
        this.setState({
            currentSlide: 1,
        });
    };

    stepForward = () => {
        this.setState({
            currentSlide: 2,
        });
    };

    submit = () => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const payload: ISubmitReviewDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            overallQuality: this.state.overall_quality,
            easeOfUse: this.state.ease_of_use,
            featuresAndFunctionality: this.state.features_and_functionality,
            valueForMoney: this.state.value_for_money,
            wouldYouRecommendUs: this.state.would_you_recommend_us,
            customerSupport: this.state.customer_support,
            whatLikeMost: this.state.what_like_most,
            whatLikeLeast: this.state.what_like_least,
            addlFeedback: this.state.addl_feedback,
        };

        this.props.socket.emit("submitReview", payload);
    };

    onSubmitReview = (data: IOnSubmitReviewDTO) => {
        this.setState(
            {
                currentSlide: 3,
                reviewLinks: data.reviewLinks,
                averageRating: data.averageRating,
                showConfetti: true,
            },
            () => {
                // setTimeout(() => {
                //     this.setState({
                //         showConfetti: false,
                //     });
                // }, 500);
            }
        );
    };

    render() {
        const questionClassName = "mt-3";

        return (
            <div className="FeedbackReviewModal p-3">
                <Confetti run={this.state.showConfetti} recycle={false} />
                <div className={"d-flex w-100 justify-content-end"}>
                    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.props.closeModal} />
                </div>
                <div>
                    <OwTitle leftIconName={"fas fa-thumbs-up"} title={"leave_feedback"} tag={"h4"} />
                </div>

                <div className={"d-flex steps"}>
                    <div className={"slide-1-circle " + (this.state.currentSlide > 1 ? "selected" : "")}>
                        <div className={"d-flex justify-content-center mb-2 "}>
                            <div className={"circle"} />
                        </div>
                        <div className={"font-small text-muted text-truncate-mobile step-title "}>
                            <OwLabel noBottomMargin={true} title={"step_one"} />
                        </div>
                    </div>

                    <div className={"line " + (this.state.currentSlide > 1 ? "selected" : "")}>
                        <i className={"fas fa-chevron-double-right"} />
                    </div>

                    <div className={"slide-2-circle " + (this.state.currentSlide > 2 ? "selected" : "")}>
                        <div className={"d-flex justify-content-center mb-2 "}>
                            <div className={"circle"} />
                        </div>
                        <div className={"font-small text-muted text-truncate-mobile step-title "}>
                            <OwLabel noBottomMargin={true} title={"step_two"} />
                        </div>
                    </div>

                    <div className={"line " + (this.state.currentSlide > 2 ? "selected" : "")}>
                        <i className={"fas fa-chevron-double-right"} />
                    </div>

                    <div className={"slide-2-circle " + (this.state.currentSlide === 3 ? "selected" : "")}>
                        <div className={"d-flex justify-content-center mb-2 "}>
                            <div className={"circle"} />
                        </div>
                        <div className={"font-small text-muted text-truncate-mobile step-title "}>
                            <OwLabel noBottomMargin={true} title={"done"} />
                        </div>
                    </div>
                </div>

                <div className={"slides"}>
                    <div className={"slide-1 " + (this.state.currentSlide === 1 ? "" : "d-none")}>
                        <div>
                            <OwLabel title={"overall_quality"} showIsReqAsterik={true} />
                            <OwStarRating name={"overall_quality"} fn={this.handleChange} />
                        </div>

                        <div className={questionClassName}>
                            <OwLabel title={"ease_of_use"} showIsReqAsterik={true} />
                            <OwStarRating name={"ease_of_use"} fn={this.handleChange} />
                        </div>

                        <div className={questionClassName}>
                            <OwLabel title={"features_and_functionality"} showIsReqAsterik={true} />
                            <OwStarRating name={"features_and_functionality"} fn={this.handleChange} />
                        </div>

                        <div className={questionClassName}>
                            <OwLabel title={"value_for_money"} showIsReqAsterik={true} />
                            <OwStarRating name={"value_for_money"} fn={this.handleChange} />
                        </div>

                        <div className={questionClassName}>
                            <OwLabel title={"would_you_recommend_us"} showIsReqAsterik={true} />
                            <OwStarRating name={"would_you_recommend_us"} fn={this.handleChange} />
                        </div>

                        <div className={questionClassName}>
                            <OwLabel title={"customer_support"} showIsReqAsterik={false} />
                            <OwStarRating name={"customer_support"} fn={this.handleChange} />
                        </div>
                    </div>

                    <div className={"slide-2 " + (this.state.currentSlide === 2 ? "" : "d-none")}>
                        <div className={""}>
                            <OwLabel title={"pros"} isBold={true} showIsReqAsterik={true} noBottomMargin={true} />
                            <div>
                                <OwLabel title={"what_do_you_like_most_about_orderwerks"} />
                            </div>

                            <OwTextArea name={"what_like_most"} fn={this.handleChange} value={this.state.what_like_most} />
                        </div>

                        <div className={"mt-3"}>
                            <OwLabel title={"cons"} isBold={true} showIsReqAsterik={true} noBottomMargin={true} />
                            <div>
                                <OwLabel title={"what_do_you_like_least_about_orderwerks"} />
                            </div>

                            <OwTextArea name={"what_like_least"} fn={this.handleChange} value={this.state.what_like_least} />
                        </div>

                        <div className={"mt-3"}>
                            <OwLabel title={"other"} isBold={true} noBottomMargin={true} />
                            <div>
                                <OwLabel title={"would_you_like_to_leave_any_additional_feedback"} />
                            </div>

                            <OwTextArea name={"addl_feedback"} fn={this.handleChange} value={this.state.addl_feedback} />
                        </div>
                    </div>

                    <div className={"slide-3 " + (this.state.currentSlide === 3 ? "" : "d-none")}>
                        <div className={"text-center"}>
                            <OwTitle title={"thank_you"} />
                        </div>

                        <div className={"mt-3 text-center"}>
                            <OwLabel title={"we_appreciate_your_feedback"} />
                        </div>

                        <div className={"mt-3"}>
                            <div className={"d-flex flex-column text-center"}>
                                <OwLabel title={"additional_review_options"} />
                                <OwLabel title={"any_additional_reviews_wed_appreciate"} className={"text-muted"} />
                            </div>
                            <div className={"text-center"}>
                                {this.state.reviewLinks.map((link, index) => {
                                    return (
                                        <div key={index}>
                                            <div>
                                                <a href={link.link} target={"_blank"} rel="noreferrer">
                                                    {link.title}
                                                </a>
                                                {link.offer && link.offer.length ? (
                                                    <span className={"ms-2"}>
                                                        <OwLabel title={"offer"} className={"me-2"} isBold={true} noBottomMargin={true} />
                                                        {link.offer}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"d-flex mt-3"}>
                    <OwButton
                        disabled={this.state.nextDisabled}
                        className={"btn-warning " + (this.state.currentSlide === 1 ? "" : "d-none")}
                        title={"next"}
                        fn={this.stepForward}
                    />

                    <OwButton
                        className={"btn-warning me-auto " + (this.state.currentSlide === 2 ? "" : "d-none")}
                        title={"back"}
                        fn={this.stepBack}
                    />

                    <OwButton
                        disabled={this.state.submitDisabled}
                        active={this.state.submitActive}
                        disableOnActive={true}
                        className={"btn-primary " + (this.state.currentSlide === 2 ? "" : "d-none")}
                        title={"submit"}
                        fn={this.submit}
                    />
                </div>
            </div>
        );
    }
}

export default FeedbackReviewModal;
